import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail } from 'lucide-react';
import FormFieldIcon from '../FormFieldIcon';
import { StyledSignUp } from './Otp/Otp.styles';
import { FormContent } from '../Login/Login.styles';
import Field from '../Field';
import Form from '../Form/Form';
import { useForm } from '../Form';
import Button from '../Button';
import authService from '../../services/authService';
import Toast from '../Toast';
import OnboardingTemplate from '../OnboardingTemplate';

const ForgotPassword = () => {
  const [form] = useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function handelResetPassword(e) {
    const payload = { email: e.email };
    setLoading(true);
    try {
      const resp = await authService.sendOtp(payload);
      if (resp.message) {
        localStorage.setItem('otp_email', e.email);
        Toast({
          type: 'info',
          message: resp.message,
        });
        setLoading(false);
        navigate('/verify-email');
      }
    } catch (error) {
      Toast({
        type: 'error',
        message: error.message,
      });
      setLoading(false);
    }
  }
  return (
    <OnboardingTemplate>
      <FormContent>
        <StyledSignUp>
          <div className="heading-text">
            <h1>Forgot Password!</h1>
            <p>
              Please enter your registered email address
              <br /> below to initiate password reset request.
            </p>
          </div>
          <div className="login-body">
            <Form form={form} className="input-wrap" onSubmit={handelResetPassword}>
              <Form.Item
                label="Email Address"
                type="email"
                name="email"
                placeholder="jhon@example.com"
                $bgWhite
                rules={[
                  {
                    required: true,
                  },
                ]}
                prefix={<FormFieldIcon icon={Mail} size={20} />}>
                <Field />
              </Form.Item>

              <Button width="100%" delayAnimation loader={loading}>
                Send OTP!
              </Button>
            </Form>
          </div>
        </StyledSignUp>
      </FormContent>
    </OnboardingTemplate>
  );
};

export default ForgotPassword;
